export function hasNotifications(notifications) {
  return notifications?.length > 0
}
